// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"styles_dashboardContainer__ffC4i","content":"styles_content__BeMNi","icon":"styles_icon__4jNHb"};